import { Box, Typography } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import { SignupProvider } from './signup/signup.context'
import { AlumeLogo } from './alume-logo'
import { routes } from '@/router'

function BrandPanel() {
  return (
    <Box
      aria-hidden
      sx={{
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '40%',
        maxWidth: 520,
        minHeight: '100vh',
        position: 'sticky',
        top: 0,
        alignSelf: 'flex-start',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        px: 6,
        py: 6,
        pb: 5,
        overflow: 'hidden',
      }}
    >
      <AlumeLogo titleAccess="Alume" />
      <Box
        component="svg"
        viewBox="0 0 600 200"
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
        sx={{
          position: 'absolute',
          left: '-10%',
          right: '-10%',
          bottom: '22%',
          width: '120%',
          opacity: 0.18,
          pointerEvents: 'none',
        }}
      >
        <path d="M0 150 C150 40 300 200 600 60" />
        <path d="M0 160 C150 50 300 210 600 70" />
        <path d="M0 170 C150 60 300 220 600 80" />
        <path d="M0 180 C150 70 300 230 600 90" />
        <path d="M0 190 C150 80 300 240 600 100" />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.75,
          position: 'relative',
        }}
      >
        <Typography
          sx={{
            fontSize: '1.75rem',
            lineHeight: 1.25,
            fontWeight: 500,
            maxWidth: '16ch',
          }}
        >
          Contabilidade e{' '}
          <Box component="span" sx={{ color: 'secondary.main' }}>
            serviços financeiros
          </Box>{' '}
          descomplicados para a sua{' '}
          <Box component="span" sx={{ color: 'secondary.main' }}>
            jornada profissional
          </Box>
        </Typography>
        <Typography sx={{ opacity: 0.7, fontSize: '0.9rem' }}>
          Soluções simples e digitais.
        </Typography>
      </Box>
    </Box>
  )
}

export function SessionPage() {
  const { pathname } = useLocation()
  const isWelcome =
    pathname === routes.session.welcome || pathname === '/session'

  return (
    <SignupProvider>
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          bgcolor: 'background.default',
        }}
      >
        {!isWelcome && <BrandPanel />}
        <Box
          component="main"
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </SignupProvider>
  )
}
